// File: components/constants.ts
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import TabletOutlinedIcon from "@mui/icons-material/TabletOutlined";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import { SvgIconComponent } from "@mui/icons-material";

export const COMPONENT_TYPES = {
  TEXT: "text",
  WIDGET: "widgets",
};

export const DEVICE_CONFIG: Record<
  string,
  { Icon: SvgIconComponent; label: string }
> = {
  mobile: { Icon: SmartphoneIcon, label: "Mobile" },
  tablet: { Icon: TabletOutlinedIcon, label: "Tablet" },
  desktop: { Icon: DesktopWindowsOutlinedIcon, label: "Desktop" },
};
